import * as React from 'react';
import './index.css';
import TrackUtils, { EVENT_TYPE } from '../../utils/TrackUtils';

interface IProps {
  goodsName?: string;
  lab: any;
  stickyTitle: boolean;
}

export default class NavigationBar extends React.Component<IProps> {
  render(): React.ReactNode {
    const {
      goodsName, lab, stickyTitle,
    } = this.props;
    const top = Mach.env.statusBarHeight; // 状态栏
    const containerHeight = top + 48; // 加上x号的容器高度。需要和x号一行

    return (
      <view className="navigation-container" style={{ backgroundColor: stickyTitle ? '#FFFFFF' : 'transparent', height: containerHeight, }}>
        <view className="header-container">
          <view className="navi-icon" />
          {
            stickyTitle && (
              <view style={{ width: Mach.env.screenWidth - 88, justifyContent: 'center', paddingTop: top, }}>
                <text className="header-title" content={goodsName} />
              </view>
            )
          }
          <image
            className="navi-icon"
            style={{ opacity: 0 }}
            src="assets://shop/icon_good_detail_share.png"
            onClick={() => {
              TrackUtils.reportShareBtn(EVENT_TYPE.MC, lab);
              console.log('点击分享当前商品');
            }}
          />
        </view>
      </view>
    );
  }
}
